import { financialCodes } from "data";
import { SelectProps } from "@amzn/awsui-components-react";

/**
 * Response interface that represent the finance codes response format
 *
 * @interface
 * @property {string} [key] - Finance code key-value pairs where key is the code identifier and value is the code description
 */
export interface FinanceCodesResponse {
    [key: string]: string;
}

/**
 * Custom hook that transforms finance codes data into select options format
 *
 * @returns {SelectProps.Options} Array of select options with finance codes as labels and values
 */
export const useFinanceCodesForSelect = (): SelectProps.Options => {
    const codes: FinanceCodesResponse = financialCodes;

    return Object.entries(codes).map(([key, label]) => ({
        label: label,
        value: key,
    }));
};
